import React from "react"
import SimpleTable from "../../components/SimpleTable"
import _ from "lodash"
import * as utils from "../../utils"
import * as strings from "../../strings"

const TABLE_COLUMNS = {
  debtorName: {
    title: strings.generalStrings.debtor,
    align: "left",
  },
  idc: {
    title: strings.generalStrings.idc,
    align: "left",
  },
  processNumber: {
    title: strings.generalStrings.processNumber,
    align: "left",
  },
  expensesCount: {
    title: strings.expenses.expenseCount,
    align: "left",
  },
  expensesValue: {
    title: strings.generalStrings.totalValue,
    align: "left",
  },
}

const prepareDebtPhases = debtPhases => debtPhases
  .map( debtPhase => ( {
    ...debtPhase,
    expensesCount: debtPhase.expenses.length,
    expensesValue:  _.chain( debtPhase.expenses )
      .map( exp => parseFloat( exp.value ) )
      .sum()
      .thru( utils.formatCurrency )
      .value(),
  } ) )

const DebtPhasesTable = ( {
  debtPhases,
  selectedDebtPhases,
  onSelect,
} ) => (
  <SimpleTable
    columns={TABLE_COLUMNS}
    data={prepareDebtPhases( debtPhases )}
    selectable={!!onSelect}
    onSelectedItemsChange={onSelect}
    selectedItems={selectedDebtPhases}
  />
)

export default DebtPhasesTable



// WEBPACK FOOTER //
// ./src/views/CreateBillingOrder/DebtPhasesTable.jsx